import { useQuery } from "@apollo/client";

import { GET_LEGAL_TERMS } from "./terms.queries";

export interface UseGetLegalTermProps {
  data: any;
  error: any;
  loading: boolean;
}

export const useGetLegalTerm = (): UseGetLegalTermProps => {
  const { loading, data, error } = useQuery(GET_LEGAL_TERMS);
  return { loading, data, error };
};
